enum Mutation {
  START_POLLING = 'startPolling',
  STOP_POLLING = 'stopPolling',
  REMOVE_POLLING = 'removePolling',
  UPDATE_TIMEOUT_ID = 'updateTimeoutId',
}

export default Mutation;
